import { TextPoint } from '../types/homepage'

export const privacyChoices: TextPoint[] = [
  {
    title: 'Review what represents you',
    description: 'Review and correct the summary of your story.',
  },
  {
    title: 'Understand what is shared',
    description: 'See what information is intended for your therapist.',
  },
  {
    title: 'Set your boundaries',
    description:
      'Make room for topics you’re ready to discuss—and those you’re not.',
  },
]
